export interface Translation {
  code: string;
  name: string;
}

export const EN_TRANSLATIONS: Translation[] = [
  { code: "KJV", name: "King James Version" },
  { code: "NKJV", name: "New King James Version" },
  { code: "NIV", name: "New International Version" },
  { code: "ESV", name: "English Standard Version" },
  { code: "NLT", name: "New Living Translation" },
  { code: "NASB", name: "New American Standard Bible" },
  { code: "CSB", name: "Christian Standard Bible" },
  { code: "NRSV", name: "New Revised Standard Version" },
];
